export function initialize() {
    let nav = document.getElementById("nav");
    let navbox = document.getElementById("nav-box");
    let navbarCollapse = document.getElementById("navbarCollapse");
    let navboxInverse = document.getElementById("nav-box-inverse");
    let bgFixedMenu = document.getElementById("bg-fixed-menu");
    let separatorMenu = document.getElementById("separator-menu");

    if(navbox === null) {
        return;
    }

    let sticky = navbox.offsetTop;

    window.onscroll = function() {
        if (window.pageYOffset >= sticky) {
            nav.classList.add('bg-menu-fixed');
            navbox.classList.add('fixed-top', 'bg-menu-fixed');
            navbarCollapse.classList.add('bg-menu-fixed');

            if(navboxInverse) {
                navboxInverse.classList.add('fixed-inverse');
            }

            bgFixedMenu.classList.remove('d-none');
            separatorMenu.classList.add('separator-menu');
        } else {
            nav.classList.remove('bg-menu-fixed');
            navbox.classList.remove('fixed-top', 'bg-menu-fixed');
            navbarCollapse.classList.remove('bg-menu-fixed');

            if(navboxInverse) {
                navboxInverse.classList.remove('fixed-inverse');
            }

            bgFixedMenu.classList.add('d-none');
            separatorMenu.classList.remove('separator-menu');
        }
    };
}

